import React from 'react';

interface BCPStepIndicatorProps {
  currentStep: number;
  steps?: string[];
}

const BCPStepIndicator: React.FC<BCPStepIndicatorProps> = ({
  currentStep,
  steps = ['企業情報登録', 'BCP作成', '完成・ダウンロード']
}) => {
  return (
    <div className="pt-2 pb-0 flex items-center justify-center">
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isActive = stepNumber === currentStep;
        const isLastStep = index === steps.length - 1;

        return (
          <React.Fragment key={index}>
            <div className="flex items-center">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-sm ${
                  isActive ? 'bg-[#0d357f] text-white font-light' : 'bg-[#e5e7eb] text-[#6b7280] font-light'
                }`}
                style={{ lineHeight: '20px' }}
              >
                {stepNumber}
              </div>
              <span
                className={`ml-2 text-sm ${
                  isActive ? 'font-medium text-[#111827]' : 'font-light text-[#6b7280]'
                }`}
                style={{ lineHeight: '20px' }}
              >
                {step}
              </span>
            </div>

            {/* 接続線 - 最後のステップ以外に表示 */}
            {!isLastStep && (
              <div className="ml-4 mr-4 w-8 h-1 bg-[#e5e7eb] rounded" />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default BCPStepIndicator;
